<template>
  <div class="product-container" ref="container">
    <div class="product-container-main">
      <Header></Header>
      <div class="header-center">
        <Search></Search>
        <nav-menu :lists="lists" :column="column"></nav-menu>
      </div>
      <div class="bread"></div>
      <div class="body-center">
        <div class="product-img-message">
          <div class="product-img">
            <div class="bigImg-container">
              <el-image style="width: 420px; height: 420px" v-if="bigimg" class="big-img" :src="bigimg"
                :fit="'contain'"></el-image>
              <img v-else class="no-img" src="../../../assets/product/bigImg.png" alt />
            </div>
            <div class="img-banner">
              <el-button :class="ltdDisabled ? 'lt disabled' : 'lt'" :disabled="ltdDisabled" @click="moveToRight">
                <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2018"
                  xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20">
                  <path
                    d="M622.927311 789.137615c-6.503881 0-13.007763-2.16796-18.066337-7.226535l-231.249118-231.249118c-10.117149-10.117149-15.898377-23.847565-15.898377-39.023289 0-14.45307 5.781228-28.183486 15.898377-39.023288l231.971771-231.971772c10.117149-10.117149 26.015526-10.117149 35.410022 0 10.117149 10.117149 10.117149 26.015526 0 35.410021l-231.249118 231.971772c-0.722653 0.722653-1.445307 2.16796-1.445307 2.890614 0 0.722653 0 2.16796 1.445307 2.890614l231.249118 231.249118c10.117149 10.117149 10.117149 26.015526 0 35.410021-5.058574 5.781228-11.562456 8.671842-18.066338 8.671842z"
                    p-id="2019" fill="#fff" />
                </svg>
              </el-button>
              <div class="list-container" ref="list-container">
                <ul class="list" ref="list">
                  <li class="smallImg-container" @mouseover="over(value)" v-for="(value, index) in imgs" :key="index">
                    <img class="small-img" :src="value" alt />
                  </li>
                </ul>
              </div>
              <el-button :class="gtdDisabled ? 'gt disabled' : 'gt'" :disabled="gtdDisabled" @click="moveToLeft">
                <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2507"
                  xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20">
                  <path
                    d="M385.174312 788.414961c-6.503881 0-13.007763-2.16796-18.066337-7.226535-10.117149-10.117149-10.117149-26.015526 0-35.410021l231.249117-231.249118c1.445307-1.445307 1.445307-4.335921 0-5.781228l-231.249117-232.694425c-10.117149-10.117149-10.117149-26.015526 0-36.132674s26.015526-10.117149 36.132674 0l231.971772 231.971771c21.679605 21.679605 21.679605 56.366972 0 77.323924l-231.249118 231.249118c-5.781228 5.781228-12.285109 7.949188-18.788991 7.949188z"
                    p-id="2508" fill="#fff" />
                </svg>
              </el-button>
            </div>
          </div>
          <div class="product-message" v-if="state">
            <div class="trade-name">{{ goodsName }}</div>
            <div class="vice-title">
              <div class="promotion">{{ goodsInfo }}</div>
              <div class="vice-collection" @click="inCollection">
                <img :src="flagCollection" />
                收藏
              </div>
            </div>
            <div v-if="status === 1">
              <!-- 普通商品 -->
              <div class="price" v-if="promotion === 0">
                <div class="price-content">
                  <span class="space4">价格</span>
                  <span v-if="price !== ''" class="DF3445">￥{{ price }}</span>
                  <span v-else class="no-price">登录享优惠</span>
                </div>

                <div class="commission-content" v-if="isModuleSelection && price">
                  <p class="rate">抽佣比例：{{ commissionRate.toFixed(2) }}%</p>
                  <p>
                    抽佣金额：{{ ((commissionRate * price) / 100).toFixed(2) }}
                  </p>
                  <p>
                    样品价格：{{
                    (
                    price - ((commissionRate * price) / 100).toFixed(2)
                    ).toFixed(2)
                    }}
                  </p>
                </div>
              </div>
              <!-- 预促销商品 -->
              <div class="promotion-not-start" v-if="promotion === 1">
                <div class="time">
                  <div class="time-left">
                    <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                      p-id="2121" width="20" height="20" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path
                        d="M507.773234 566.661947c-18.053168 0-32.661887-14.638395-32.661887-32.661887 0-18.052145 14.608719-32.659841 32.661887-32.659841 60.217477 0 120.43393 0 180.590008 0 18.052145 0 32.661887 14.607696 32.661887 32.659841 0 18.023492-14.609743 32.661887-32.661887 32.661887C628.207164 566.661947 567.99071 566.661947 507.773234 566.661947zM477.12112 376.50198c0-18.018376 14.640442-32.660864 32.692586-32.660864 17.987676 0 32.659841 14.642488 32.659841 32.660864L542.473547 533.237697c0 18.052145-14.672164 32.659841-32.659841 32.659841-18.052145 0-32.692586-15.117302-32.692586-33.171494L477.12112 376.50198zM509.813706 109.413945c117.120464 0 223.266993 47.555086 300.06817 124.360356l0.127913 0c76.806293 76.801177 124.32761 182.981475 124.32761 300.225759 0 117.121488-47.521317 223.268016-124.32761 300.069193l-0.127913 0.127913c-76.8022 76.806293-182.947705 124.391055-300.06817 124.391055-117.246331 0-223.423559-47.52234-300.260551-124.391055l0-0.127913C132.749932 757.268076 85.194846 651.121548 85.194846 534.00006c0-117.244284 47.555086-223.424582 124.358309-300.225759C286.390147 156.939355 392.567375 109.413945 509.813706 109.413945L509.813706 109.413945zM763.891426 279.893688c-65.001433-64.967664-154.884556-105.159038-254.077719-105.159038-99.224886 0-189.073216 40.220027-254.076696 105.22146-65.001433 64.97278-105.22146 154.822135-105.22146 254.04395 0 99.258655 40.220027 189.076286 105.156992 254.077719l0.064468-0.061398c65.00348 65.001433 154.850787 105.251136 254.076696 105.251136 99.193163 0 189.076286-40.249703 254.077719-105.189737 64.937988-65.001433 105.124246-154.819065 105.124246-254.077719 0-99.221816-40.186258-189.07117-105.188714-254.04395L763.891426 279.893688zM228.404502 70.533426c13.999852-11.351536 34.541701-9.214872 45.929052 4.783956 11.352559 13.973246 9.249665 34.576493-4.753257 45.961798L142.860197 224.206388c-14.000875 11.384281-34.57547 9.248641-45.959751-4.754281-11.355629-14.002922-8.835226-34.892695 5.16565-46.278L228.404502 70.533426zM791.191188 70.533426c-14.030551-11.351536-34.574447-9.214872-45.929052 4.783956-11.418051 13.973246-9.249665 34.576493 4.722558 45.961798l126.749776 102.927207c13.96813 11.384281 34.576493 9.248641 45.929052-4.754281 11.354606-14.002922 8.865925-34.892695-5.166673-46.278L791.191188 70.533426z"
                        fill="#999999" p-id="2122" />
                    </svg>促销预告
                  </div>
                  <div class="time-right">{{ this.time }} 开启</div>
                </div>
                <!-- 价格 -->
                <div v-if="price !== ''" class="promotion-price">
                  <span class="promotion-price-title">价格</span>
                  <p>
                    <i>￥</i>
                    <span>{{ price }}</span>
                  </p>
                </div>
                <div v-else class="promotion-price">
                  <span class="promotion-price-title">价格</span>
                  <p>登录享优惠</p>
                </div>
                <!-- 佣金 -->
                <div class="commission-content" v-if="isModuleSelection && price">
                  <p class="rate">抽佣比例：{{ commissionRate.toFixed(2) }}%</p>
                  <p>
                    抽佣金额：{{ ((commissionRate * price) / 100).toFixed(2) }}
                  </p>
                  <p>
                    样品价格：{{
                    (
                    price - ((commissionRate * price) / 100).toFixed(2)
                    ).toFixed(2)
                    }}
                  </p>
                </div>
                <!-- 促销信息 -->
                <div class="promotion-message">
                  <span class="promotion-message-title">促销</span>
                  <div class="promotion-message-content">
                    <p class="promotion-message-list">
                      <span class="promotion-message-lable">{{
                        ruleType == 1 ? "直降" : "满减"
                        }}</span>
                      <span>{{ reduction }}</span>
                    </p>
                    <p class="promotion-message-list">
                      <span class="promotion-message-lable">时间</span>
                      <span>{{ timeFrame }}</span>
                    </p>
                    <p class="promotion-message-list" v-if="purchaseLimitNum > 0">
                      <span class="promotion-message-lable">限购</span>
                      <span>每位用户最多可优惠购买{{ purchaseLimitNum }}件</span>
                    </p>
                  </div>
                </div>
              </div>
              <!-- 促销商品 -->
              <div class="promotion-start" v-if="promotion === 2">
                <div class="time" v-if="onPromotion">
                  <div class="time-left">
                    <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                      p-id="1864" width="22" height="22" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path
                        d="M337.972914 87.513047c13.786302-50.649674 68.931509-87.513047 119.481283-87.513047h137.863019c50.549774 0 73.526943 36.863372 55.145207 82.917613l-114.885849 271.829909h197.603661c101.099547 0 128.672151 64.535877 64.336075 138.262621l-431.870892 506.796446c-32.168038 36.863372-50.549774 32.267938-36.763471-18.381736l91.908679-382.420026h-160.840189c-50.549774 0-78.122377-36.863372-64.336075-87.513047L337.972914 87.513047z"
                        p-id="1865" fill="#ffffff" />
                    </svg>
                    {{isAcvitity == 1?'活动卖场':'促销'}}
                  </div>
                  <div class="time-right">{{ this.time }}</div>
                </div>
                <!-- 价格 -->
                <div v-if="price !== ''" class="promotion-price">
                  <span class="promotion-price-title">价格</span>
                  <div class="price-container" v-if="promotionType === 1">
                    <template v-if="onPromotion">
                      <p class="new-price">
                        <i>￥</i>
                        <span>{{ (price - reductionPrice).toFixed(2) }}</span>
                      </p>
                      <p class="old-price">
                        <i>￥</i>
                        <span>{{ price }}</span>
                      </p>
                    </template>
                    <template v-else>
                      <p class="new-price">
                        <i>￥</i>
                        <span>{{ price }}</span>
                      </p>
                    </template>
                  </div>
                  <div class="price-container" v-else>
                    <p class="new-price">
                      <i>￥</i>
                      <span>{{ price }}</span>
                    </p>
                  </div>
                </div>
                <div v-else class="promotion-price">
                  <span class="promotion-price-title">价格</span>
                  <p>登录享优惠</p>
                </div>
                <!-- 佣金 -->
                <div class="commission-content" v-if="isModuleSelection && price">
                  <p class="rate">抽佣比例：{{ commissionRate.toFixed(2) }}%</p>
                  <p>
                    抽佣金额：{{ ((commissionRate * price) / 100).toFixed(2) }}
                  </p>
                  <p>
                    样品价格：{{
                    (
                    price - ((commissionRate * price) / 100).toFixed(2)
                    ).toFixed(2)
                    }}
                  </p>
                </div>
                <!-- 促销信息 -->
                <div class="promotion-message" v-if="onPromotion">
                  <span class="promotion-message-title">{{isAcvitity == 1?'活动':'促销'}}</span>
                  <div class="promotion-message-content">
                    <p class="promotion-message-list">
                      <span class="promotion-message-lable">{{
                        ruleType == 1 ? "直降" : "满减"
                        }}</span>
                      <span>{{ reduction }}</span>
                    </p>
                    <p class="promotion-message-list">
                      <span class="promotion-message-lable">时间</span>
                      <span>{{ timeFrame }}</span>
                    </p>
                    <p class="promotion-message-list" v-if="purchaseLimit > 0">
                      <span class="promotion-message-lable">限购</span>
                      <span>每位用户最多可优惠购买{{ purchaseLimit }}件</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="market-price" v-if="isVisitorPrice">
                <span class="market-price-tit">游客价</span>
                <span class="market-original-price">￥{{ visitorPrice }}</span>
              </div>
              <div class="specification">
                <sku-select @has-select-sku="onSelectedSku" :skuOriginData="skuOriginData"></sku-select>
              </div>
              <div class="points" v-if="points">
                <span class="points-tit">积分</span>
                <span>赠送{{points}}积分</span>
              </div>
              <div class="address" v-if="isModuleStorage">
                <span class="address-tit">送至</span>
                <span class="address-content address-red" v-if="!address" @click="openAddress">请选择收货区域</span>
                <span class="address-content" v-else>
                  <span class="address-text">{{ address }}</span>
                  <span class="address-red" @click="openAddress">重选</span>
                </span>
              </div>
              <!-- <div class="address">
                <span class="address-tit">送至</span>
                <span
                  class="address-content address-red"
                  v-if="!address"
                  @click="openAddress"
                >请选择收货区域</span>
                <span class="address-content" v-else>
                  <span class="address-text">{{ address }}</span>
                  <span class="address-red" @click="openAddress">重选</span>
                </span>
              </div>-->
              <div class="number">
                <span class="number-tit">数量</span>
                <el-input-number v-if="purchaseLimit > 0 && stock > purchaseLimit" v-model="num"
                  controls-position="right" :min="1" :max="purchaseLimit"></el-input-number>
                <el-input-number v-if="purchaseLimit > 0 && stock <= purchaseLimit" v-model="num"
                  controls-position="right" :min="1" :max="stock"></el-input-number>
                <el-input-number v-if="purchaseLimit === 0" v-model="num" controls-position="right" :min="1"
                  :max="stock"></el-input-number>
                <p class="stock">
                  库存{{ stock }}件
                  <span v-if="address">(包含本地仓{{ localSaleNum }}件，总仓{{ saleNum }}件)</span>
                </p>
              </div>
              <div class="button addCart">
                <el-button v-if="stock > 0" class="add-to-cart" @click="inCart({})">加入购物车</el-button>
                <el-button v-else class="nothing" disabled>商品已售罄</el-button>
                <!-- <el-button class="collection" @click="inCollection">收藏</el-button> -->
                <el-button v-if="isModuleSelection" :class="
                    stock > 0
                      ? 'add-to-select'
                      : 'add-to-select disabled-select'
                  " :disabled="stock <= 0" @click="inSelectionCart">加入选品池</el-button>
                <el-button :class="stock > 0 ? 'sample' : 'disabled-sample'" v-if="isModuleSelection"
                  :disabled="stock <= 0" @click="sample">购买样品</el-button>
                <transition v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter"
                  v-on:enter-cancelled="enterCancelled">
                  <div v-show="addCartShow" class="img-fade-container">
                    <el-image style="width: 25px; height: 25px" :fit="'contain'" v-if="imgs[0]"
                      :src="imgs[0]"></el-image>
                    <el-image style="width: 25px; height: 25px" :fit="'contain'" v-else
                      src="http://image.8844it.com/ydb2/goodDefault.png"></el-image>
                  </div>
                </transition>
              </div>
            </div>
            <div class="lower-shelf" v-else>商品已下架</div>
          </div>
          <div class="product-delete" v-else>该商品不存在</div>
        </div>
        <!-- 套餐 -->
        <div class="package" v-if="packageData.length > 0">
          <el-tabs type="border-card">
            <el-tab-pane v-for="(value, index) in packageData" :key="index">
              <span slot="label" :title="value.title">{{ value.title }}</span>
              <ul class="package-list">
                <li v-for="(v, i) in value.items" :key="i">
                  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1479"
                    xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16">
                    <path d="M536.2 541.2v270.4h-50.6V541.2h-270v-50.6h270v-271h50.6v271h270.4v50.6H536.2z" p-id="1480"
                      fill="#606266" />
                  </svg>
                  <div class="img">
                    <img :src="v.img" alt @click="goToProduct(v.id)" />
                  </div>
                  <p class="tit" @click="goToProduct(v.id)" :title="v.name">
                    {{ v.name }}
                  </p>
                  <p class="price" v-if="price !== ''">￥{{ v.price }}</p>
                  <p class="price" v-else>登录享优惠</p>
                  <p class="quantity">数量：{{ v.quantity }}</p>
                </li>
              </ul>
              <div class="total-price">
                <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1706"
                  xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20">
                  <path d="M223 406.5v-51.3h591v51.3H223z m0 302.8V658h591v51.3H223z" p-id="1707" fill="#7D7D7D" />
                </svg>
                <p class="package-price">
                  <span class="tit">套餐价：</span>
                  <span class="prc" v-if="price !== ''">￥{{ value.price }}</span>
                  <span class="prc" v-else>登录享优惠</span>
                </p>
                <p class="price">
                  <span class="tit">价格：</span>
                  <span class="prc" v-if="price !== ''">{{ value.oldPrice }}</span>
                  <span class="prc" v-else>登录享优惠</span>
                </p>
                <div class="number-price">
                  <el-input-number class="white" controls-position="right" v-model="setMealNum" :min="1"
                    @input.native="inputUnitPrice"></el-input-number>
                </div>
                <!-- <el-button @click="toSettle(value.id, setMealNum)">立即抢购</el-button> -->
                <el-button @click="setMealJionCar(value, setMealNum)">加入购物车</el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="recommend-detail">
          <!-- 推荐商品 -->
          <div class="recommend" v-if="status === 1 && state">
            <p class="title">推荐商品</p>
            <ul class="recommend-list">
              <li v-for="(value, index) in recommendData" :key="index">
                <div class="img">
                  <img v-if="value.img" :src="value.img" alt @click="goToProduct(value.id)" />
                  <img v-else src="http://image.8844it.com/ydb2/goodDefault.png" @click="goToProduct(value.id)" alt />
                </div>
                <p class="name" @click="goToProduct(value.id)">
                  {{ value.name }}
                </p>
                <span class="price" v-if="value.price">￥{{ value.price }}</span>
                <span class="price" v-else>登录享优惠</span>
              </li>
            </ul>
          </div>
          <!-- 商品详情页 -->
          <div class="detail" v-if="status === 1 && state">
            <p class="title">商品详情</p>
            <div v-if="content" v-html="content"></div>
            <div v-else class="noContent">
              <img src="../../../assets/product/detail.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <right-sidebar :carDate="carDate" :commodityDate="commodityDate" :selectionDate="selectionDate"
      @slideStatus="slideStatus"></right-sidebar>
    <el-dialog class="address-dialog" title="添加送货区域" :close-on-click-modal="false" :visible.sync="showAddressDialog">
      <el-form :model="addressForm" :rules="addressFormRules" ref="addressForm">
        <el-form-item label="送货区域：" label-width="100px" prop="areaArr">
          <el-cascader v-model="addressForm.areaArr" :options="addressList" :props="cascaderProps"></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="cancelEditedAddress">取消</el-button>
        <el-button class="save-btn btn" @click="saveEditedAddress">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Velocity from "velocity-animate";
import {
  getToken,
  getXBGuestSetting,
  getXBBasicInformation,
  saveXbTouristCartGoods,
  getXbTouristCartGoods,
  saveXBReceivingGoodsAddressInfo,
  getXBReceivingGoodsAddressInfo,
  deleteXBReceivingGoodsAddressInfo,
} from "common/js/storage";
import eventVue from "common/js/eventBus";
import Header from "base/xb-base/Header";
import Search from "base/xb-base/Search";
import NavMenu from "base/xb-base/NavMenu";
import Footer from "base/xb-base/Footer";
import RightSidebar from "base/xb-base/RightSidebar";
import SkuSelect from "base/xb-base/SkuSelect";
import XBProduct from "models/xb/product.js";
import XBShoppingCart from "models/xb/shopping-cart.js";
import XBHome from "models/xb/home.js";
import XBRecommend from "models/xb/recommend.js";
import XBSelectionCart from "models/xb/selection-cart.js";
import ShoppingCart from "models/xb/shopping-cart.js";
import DBAddress from "models/db/address.js";
const dbAddress = new DBAddress();
const shoppingCart = new ShoppingCart();
const xbRecommend = new XBRecommend();
const xbHome = new XBHome();
const xbProduct = new XBProduct();
const xbShoppingCart = new XBShoppingCart();
const xbSelectionCart = new XBSelectionCart();
export default {
  components: {
    Header,
    Search,
    NavMenu,
    Footer,
    RightSidebar,
    SkuSelect,
  },
  data() {
    return {
      status: 1, // 当前商品状态（上架、下架）
      state: true, // 当前商品是否存在
      id: null, // 当前详情页id
      imgs: [], // 所有图片数据
      bigimg: "", // 大容器图片
      number: 1, // 记录滑动数
      ltdDisabled: true, // 左滑按钮
      gtdDisabled: false, // 右滑按钮
      goodsName: "", // 商品标题
      goodsInfo: "", // 商品副标题
      price: null, // 当前选中sku对应的价格
      onPromotion: true, // 当前选中sku是否为促销
      skuOriginData: [], // sku数据
      sku: [], // 选中的sku
      stock: 0, // 当前sku库存
      num: 1, // 商品的数量
      content: "", // 详情页内容
      lists: [], // 分类数据
      column: [], // 栏目数据
      token: "",
      touristRights: {},
      carDate: 0, // 触发加入购物车
      commodityDate: 0, // 触发加入收藏夹
      packageData: [], // 套餐数据
      recommendData: [], // 商品推荐数据
      promotion: "", // 商品是否是促销
      endTime: 0, // 促销结束时间
      time: "", // 开始时间或倒计时
      reduction: "", // 满减
      ruleType: "", // 1直降2满减
      reductionPrice: 0, //直减金额
      timeFrame: "", // 促销周期
      promotionType: "", // 促销类型（直降、满减）
      purchaseLimit: "", // 限购
      purchaseLimitNum: "", // 预购数量展示
      //加入购物车动画开关
      addCartShow: false,
      slide: false,
      //选品池
      commissionRate: "", //佣金比例
      isModuleSelection: false, //选品池状态
      selectionDate: 0, // 触发加入选品池
      address: "", //送货地址
      showAddressDialog: false,
      addressForm: {
        areaArr: [],
      },
      addressFormRules: {
        areaArr: {
          required: true,
          message: "请选择送货地区",
          trigger: "blur",
        },
      },
      // 地址列表
      addressList: [],
      // Cascader 的 props 配置
      cascaderProps: {
        value: "id",
        label: "name",
      },
      localSaleNum: 0, //本地仓
      saleNum: 0, //总仓
      addressFlag: 0,
      isModuleStorage: false,
      flagCollection: require("../../../assets/product/collection-white.png"),
      collectionImg: require("../../../assets/product/collection.png"),
      numList: [],
      numCopyList: [],
      isAcvitity: 0,
      setMealNum: 1,
      points: null,    // 赠送积分
      isVisitorPrice: false,  // 是否开启游客价开关
      visitorPrice: 0,  // 原始市场价价格
    };
  },
  watch: {
    stock: function (newVal, oldVal) {
      this.num = 1;
    },
    endTime: function (newVal, oldVal) {
      setInterval(() => {
        let stamp = this.endTime - new Date().getTime();
        let d = Math.floor(stamp / (24 * 3600 * 1000));
        let h =
          parseInt((stamp / 1000 / 3600) % 24) > 9
            ? parseInt((stamp / 1000 / 3600) % 24)
            : "0" + parseInt((stamp / 1000 / 3600) % 24);
        let m =
          parseInt((stamp / 1000 / 60) % 60) > 9
            ? parseInt((stamp / 1000 / 60) % 60)
            : "0" + parseInt((stamp / 1000 / 60) % 60);
        let s =
          parseInt((stamp / 1000) % 60) > 9
            ? parseInt((stamp / 1000) % 60)
            : "0" + parseInt((stamp / 1000) % 60);

        if (d !== 0) {
          this.time = `距结束${d}天${h}时${m}分${s}秒`;
        } else {
          this.time = `距结束${h}时${m}分${s}秒`;
        }
      }, 1000);
    },
  },
  created() {
    if (getXBBasicInformation() !== "") {
      this.isModuleStorage = getXBBasicInformation().moduleStorage === 1 ? true : false;
      this.isVisitorPrice = getXBBasicInformation().moduleVisitorIncrement === 1 ? true : false;
      if (!this.isModuleStorage) {
        deleteXBReceivingGoodsAddressInfo();
      }
    }
    this.isAcvitity = this.$route.query.acvitity
    this.id = Number(this.$route.query.id);
    this.initReceivingGoodsAddressInfo();
    this.getProductDetail();
    this.getMenu();
    this.getColumnData();
    this.token = getToken();
    this.touristRights = getXBGuestSetting();
    this.getPackage(this.id);
    this.getRecommend();
    // 获取城市数据列表
    this._getDBAddressMock();
  },
  mounted() {
    this.getModuleSelection();
  },
  methods: {
    /* 限制数量为整数 */
    inputUnitPrice(e) {
      let price = e.target.value.toString().match(/^(\+)?\d*/g)
        ? e.target.value === "00"
          ? "0"
          : e.target.value.toString().match(/^(\+)?\d*/g)[0]
        : "";
      e.target.value = price
    },
    //获取收货地信息
    initReceivingGoodsAddressInfo() {
      let addressList = getXBReceivingGoodsAddressInfo();
      if (addressList.length != 0) {
        this.address = `${addressList[0].name}${addressList[1].name}${addressList[2].name}`;
        this.initSaleNum(addressList[1].id, addressList[2].id);
      } else {
        this.initSaleNum('','');
      }
    },
    //初始化本地库存和总库存
    initSaleNum(city, region) {
      this.localSaleNum = "";
      this.saleNum = "";
      xbProduct.getSaleNum(this.id, city, region).then((res) => {
        if (res.success) {
          this.numList = res.result;
          if (region > 0) {
            this.numCopyList = res.result;
          }
          if (this.sku.length > 0) {
            let id = this.sku[this.sku.length - 1].id;
            res.result.map((item) => {
              if (id == item.id) {
                this.localSaleNum = item.localSaleNum ? item.localSaleNum : 0;
                this.saleNum = item.saleNum ? item.saleNum : 0;
                this.stock =
                  parseInt(this.localSaleNum) + parseInt(this.saleNum);
              }
            });
          } else {
            let localSaleNum = 0;
            let saleNum = 0;
            res.result.map((item) => {
              if (item.localSaleNum == undefined) {
                this.localSaleNum = 0;
              } else {
                localSaleNum += item.localSaleNum;
                this.localSaleNum = localSaleNum;
              }
              if (item.saleNum == undefined) {
                this.saleNum = 0;
              } else {
                saleNum += item.saleNum;
                this.saleNum = saleNum;
              }
              this.stock = parseInt(localSaleNum) + parseInt(saleNum);
            });
          }
        }
      });
    },
    // 套餐去结算
    toSettle(packageId, setMealNum) {
      console.log("套餐id", packageId);
      this.$router.push({
        path: "/confirm-order",
        query: {
          packageId: packageId,
          setMealNum: setMealNum
        },
      });
    },
    // 套餐加入购物车
    setMealJionCar(v, setMealNum) {
      if (this.token) {
        let data = {
          setMealId: v.id,
          quantity: setMealNum
        }
        this.inCart(data)
      } else {
        let arr = getXbTouristCartGoods()
        console.log('第一次',arr);
        let obj = {}
        obj.status = v.status
        obj.setMealId = v.id
        obj.number = setMealNum
        obj.oldPrice = v.oldPrice
        obj.price = v.price
        obj.title = v.title
        obj.setMealGoodsList = []
        v.items.map(i => {
          let setMealObj = {}
          setMealObj.goodsId = i.id
          setMealObj.setMealId = i.setMealId
          setMealObj.name = i.name
          setMealObj.img = i.img
          setMealObj.price = i.price
          setMealObj.number = i.quantity
          let normMap = i.title ? i.title : "{}"
          let norm = "";
          for (let key in normMap) {
            norm += `，${normMap[key]}`;
          }
          setMealObj.norm = norm.substring(1)
          setMealObj.skuId = i.skuId
          obj.setMealGoodsList.push(setMealObj)
        })
        arr.push(obj)
        console.log('第二次',arr);
        saveXbTouristCartGoods(arr)
        eventVue.$emit('uplodeCartGoods')
      }
    },
    // 获取侧边栏数据
    getMenu() {
      xbHome.getXBMenu().then((res) => {
        let arr = [];
        res.result.map((value) => {
          let object = {};
          object.name = value.name;
          object.id = value.categoryId;
          object.children = [];
          value.children.map((val) => {
            let obj = {};
            obj.name = val.name;
            obj.id = val.categoryId;
            obj.children = [];
            val.children.map((v) => {
              let o = {};
              o.name = v.name;
              o.id = v.categoryId;
              obj.children.push(o);
            });
            object.children.push(obj);
          });
          arr.push(object);
        });
        this.lists = arr;
        // console.log('this.lists', this.lists);
      });
    },
    // 获取栏目信息
    getColumnData() {
      xbHome.getXBColumn().then((res) => {
        this.column = res.result;
      });
    },
    // 获取套餐数据
    getPackage() {
      xbProduct.postXBPackage(this.id).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let object = {};
            object.title = value.title;
            object.id = value.id;
            object.status = value.status;
            if (this.token) {
              object.price = value.price;
              object.oldPrice = value.oldPrice;
            } else {
              if (this.touristRights.guestShowPrice === 1) {
                object.price = value.price;
                object.oldPrice = value.oldPrice;
              } else {
                object.price = "";
                object.oldPrice = "";
              }
            }
            object.items = [];
            value.setMealGoodsList.map((v) => {
              let obj = {};
              obj.id = v.goodsId;
              obj.setMealId = v.setMealId;
              obj.name = v.goodsName;
              obj.img = v.goodsPic;
              if (this.token) {
                obj.price = v.marketPrice;
              } else {
                if (this.touristRights.guestShowPrice === 1) {
                  obj.price = v.marketPrice;
                } else {
                  obj.price = '';
                }
              }
              obj.skuId = v.itemId;
              obj.title = JSON.parse(v.itemTitle);
              obj.quantity = v.quantity;
              object.items.push(obj);
            });
            arr.push(object);
          });
          this.packageData = arr;
        }
      });
    },
    // 获取推荐数据
    getRecommend() {
      xbRecommend.getXBRecommend().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.name = value.goodsName;
            if (value.itemImages) {
              obj.img = value.itemImages[0];
            }
            if (this.token) {
              obj.price = value.defaultPrice;
            } else {
              if (this.touristRights.guestShowPrice === 1) {
                obj.price = value.defaultPrice;
              } else {
                obj.price = "";
              }
            }
            obj.id = value.goodsId;
            arr.push(obj);
          });
          this.recommendData = arr;
        }
      });
    },
    // 获取商品详情数据
    getProductDetail() {
      let id = this.id;
      xbProduct.postXBProductDetail(id,'').then((res) => {
        if (res.success) {
          this.status = res.result.status;
          this.imgs = res.result.itemImages;
          this.bigimg = res.result.itemImages[0];
          this.gtdDisabled = !(res.result.itemImages.length > 5);
          this.goodsName = res.result.goodsName;
          this.goodsInfo = res.result.goodsInfo;
          // this.stock = res.result.totalSaleNum;
          if (res.result.promotion) {
            this.ruleType = res.result.promotion.ruleType;
          }
          this.commissionRate = res.result.commissionRate * 100;
          if (res.result.inPromotion) {
            this.timeFrame =
              this.toTime(res.result.promotion.beginTime) +
              "-" +
              this.toTime(res.result.promotion.endTime);
            this.promotionType = res.result.promotion.ruleType;
            if (this.promotionType === 1) {
              this.reduction = `商品直降${res.result.promotion.descend}元`;
              this.reductionPrice = res.result.promotion.descend;
            } else {
              let str = "";
              res.result.promotion.ladderJson.map((velue) => {
                str += `满${velue.full}件减${velue.reduce}元， `;
              });
              this.reduction = str.slice(0, str.length - 2);
            }
            if (!res.result.promotion.onPromotion) {
              this.promotion = 1;
              this.time = this.toTime(res.result.promotion.beginTime);
              this.purchaseLimit = 0;
              this.purchaseLimitNum = res.result.promotion.buyLimit;
            } else {
              this.promotion = 2;
              this.endTime = res.result.promotion.endTime;
              this.purchaseLimit = res.result.promotion.buyLimit;
              this.onPromotion = res.result.defaultSkuInPromotion;
            }
          } else {
            this.purchaseLimit = 0;
            this.promotion = 0;
          }
          if (this.token) {
            this.price = res.result.defaultPrice;
          } else {
            if (this.touristRights.guestShowPrice === 1) {
              this.price = res.result.defaultPrice;
            } else {
              this.price = "";
            }
          }
          if (res.result.introduction) {
            this.getJsonp(res.result.introduction);
          }
          let arr = [];
          res.result.items.map((value, index, array) => {
            let obj = value.specInfo;
            obj.skuId = {};
            obj.skuId.id = value.id;
            obj.skuId.onPromotion = value.onPromotion;
            if (this.token) {
              obj.skuId.price = value.marketPrice;
            } else {
              if (this.touristRights.guestShowPrice === 1) {
                obj.skuId.price = value.marketPrice;
              } else {
                obj.skuId.price = "";
              }
            }
            obj.skuId.num = value.saleNum;
            obj.skuId.points = value.points
            obj.skuId.visitorPrice = value.visitorPrice
            arr.push(obj);
          });
          this.skuOriginData = arr;

          /* --------------------- 以下是默认选择第一个sku ------------------- */
          let selectFirstSku = []
          for (let attrKey in arr[0]) {
            selectFirstSku.push(arr[0][attrKey])
          }
          this.$nextTick(() => {
            this.onSelectedSku(selectFirstSku)
          })
        } else {
          if (res.message === "商品不存在") {
            this.state = false;
          }
        }
      });
    },
    // jsonp
    getJsonp(url) {
      var hash = new Date().getTime();
      let script = document.createElement("script");
      window.jsonpCallBack = (response) => {
        let str = response.content;
        this.content = str;
      };
      script.src = url + `?hash=${hash}`;
      document.body.appendChild(script);
      script.onload = function (e) {
        e.currentTarget.remove();
        delete window.jsonpCallBack;
      };
      script.onerror = function (e) {
        // alert("数据请求失败");
        e.currentTarget.remove();
        delete window.jsonpCallBack;
      };
      window.jsonpCallback = (response) => {
        let str = response.content;
        this.content = str;
      };
      script.onload = function (e) {
        e.currentTarget.remove();
        delete window.jsonpCallback;
      };
      script.onerror = function (e) {
        // alert("数据请求失败");
        e.currentTarget.remove();
        delete window.jsonpCallback;
      };
    },
    // 左滑
    moveToLeft() {
      let containerWidth = this.$refs["list-container"].clientWidth + 20;
      let width = this.$refs["list"].clientWidth;
      if (width > containerWidth) {
        let sum = (width - containerWidth) / 80;
        if (this.number < sum) {
          this.$refs["list"].style.left = -this.number * 80 + "px";
          this.number = this.number + 1;
          this.ltdDisabled = false;
        } else if (this.number === sum) {
          this.$refs["list"].style.left = -this.number * 80 + "px";
          this.number = this.number + 1;
          this.ltdDisabled = false;
          this.gtdDisabled = true;
        } else {
          this.ltdDisabled = false;
          this.gtdDisabled = true;
        }
      }
    },
    // 右滑
    moveToRight() {
      if (this.number > 1) {
        this.number = this.number - 1;
        this.$refs["list"].style.left = -(this.number - 1) * 80 + "px";
        if (this.number === 1) {
          this.ltdDisabled = true;
          this.gtdDisabled = false;
        }
      }
    },
    // hover small-img
    over(value) {
      this.bigimg = value;
    },
    // 返回的sku数据
    onSelectedSku(item) {
      this.sku = item;
      this.visitorPrice = item[item.length - 1].visitorPrice
      this.price = item[item.length - 1].price;
      this.points = item[item.length - 1].points
      let addressList = getXBReceivingGoodsAddressInfo();
      if (addressList.length != 0 && this.addressFlag != 1) {
        this.initSaleNum(addressList[1].id, addressList[2].id);
      } else if (this.addressFlag == 1) {
        let id = this.sku[this.sku.length - 1].id;
        this.numCopyList.map((item) => {
          if (id == item.id) {
            this.localSaleNum = item.localSaleNum ? item.localSaleNum : 0;
            this.saleNum = item.saleNum ? item.saleNum : 0;
            this.stock = parseInt(this.localSaleNum) + parseInt(this.saleNum);
          }
        });
      } else {
        let localSaleNum = 0;
        let saleNum = 0;
        this.stock = item[item.length - 1].num;
        this.numList.map((v) => {
          if (item[item.length - 1].id == v.id) {
            if (v.localSaleNum == undefined) {
              localSaleNum = 0;
            } else {
              localSaleNum += v.localSaleNum;
            }
            if (v.saleNum == undefined) {
              saleNum = 0;
            } else {
              saleNum += v.saleNum;
            }
            this.stock = parseInt(localSaleNum) + parseInt(saleNum);
          }
        });
      }
      this.onPromotion = item[item.length - 1].onPromotion;
    },
    // 加入购物车
    inCart(value) {
      if (this.sku.length > 0 && Object.keys(value).length === 0) {
        if (this.token) {
          let goodsId = this.id;
          let itemId = this.sku[this.sku.length - 1].id;
          let quantity = this.num;
          let data = {
            goodsId,
            itemId,
            quantity,
          };
          xbShoppingCart.postAddShoppingCart(data).then((res) => {
            if (res.success) {
              if (!this.addCartShow) {
                let addCart = document.querySelector(".addCart");
                let imgFade = document.querySelector(".img-fade-container");
                let left = addCart.getBoundingClientRect().left;
                let top = addCart.getBoundingClientRect().top;
                imgFade.style.right = null;
                imgFade.style.position = "fixed";
                imgFade.style.left = left + "px";
                imgFade.style.top = top + "px";
                console.log(left, top);
                this.addCartShow = true;
                setTimeout(() => {
                  this.addCartShow = false;
                  this.carDate = new Date().getTime();
                }, 1000);
              } else {
                this.carDate = new Date().getTime();
              }
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          let arr = []
          let isFlag = false
          arr = getXbTouristCartGoods()
          arr.map(v => {
            if (v.skuId === this.sku[this.sku.length - 1].id) {
              if ((this.num + v.number) > this.sku[this.sku.length - 1].num) {
                isFlag = true
              }
            }
          })
          if (isFlag) {
            this.$message.error("库存不足");
            return
          }
          let obj = {}
          obj.buyLimit = 0
          obj.spareBuyLimit = 0
          obj.status = 1
          obj.isSelected = false
          obj.goodsId = this.id
          obj.name = this.goodsName
          obj.img = this.bigimg
          obj.number = this.num
          obj.skuId = this.sku[this.sku.length - 1].id
          obj.price = this.sku[this.sku.length - 1].price
          obj.reserve = this.sku[this.sku.length - 1].num
          let norm = ''
          for (let i = 0; i < this.sku.length - 1; i++) {
            norm += `，${this.sku[i]}`
          }
          obj.norm = norm.substring(1)
          arr.push(obj)
          saveXbTouristCartGoods(arr)
          eventVue.$emit('uplodeCartGoods')
        }
      } else {
        if (Object.keys(value).length > 0) {
          if (this.token) {
            let  data = value
            xbShoppingCart.postAddShoppingCart(data).then((res) => {
              if (res.success) {
                if (!this.addCartShow) {
                  let addCart = document.querySelector(".addCart");
                  let imgFade = document.querySelector(".img-fade-container");
                  let left = addCart.getBoundingClientRect().left;
                  let top = addCart.getBoundingClientRect().top;
                  imgFade.style.right = null;
                  imgFade.style.position = "fixed";
                  imgFade.style.left = left + "px";
                  imgFade.style.top = top + "px";
                  this.addCartShow = true;
                  setTimeout(() => {
                    this.addCartShow = false;
                    this.carDate = new Date().getTime();
                  }, 1000);
                } else {
                  this.carDate = new Date().getTime();
                }
              } else {
                this.$message.error(res.message);
              }
            })
          }
        } else {
          this.$message.error("请先选择规格！");
        }
      }
    },
    // 加入收藏夹
    inCollection() {
      this.flagCollection = this.collectionImg;
      let id = this.id;
      xbProduct.getXBAddCollection(id).then((res) => {
        if (res.success) {
          this.commodityDate = new Date().getTime();
          this.$message.success("收藏成功！");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //购买样品
    sample() {
      if (this.sku.length > 0) {
        if (this.num > 3) {
          this.$message.error("购买样品数量不能超过3件");
        } else {
          let selectGoodsId = this.id;
          let itemId = this.sku[this.sku.length - 1].id;
          let quantity = this.num;
          let data = {
            selectGoodsId,
            itemId,
            quantity,
          };
          xbProduct.postSample(data).then((res) => {
            if (res.success) {
              this.$router.push({
                path: "/confirm-order",
                query: {
                  sample: JSON.stringify(data),
                },
              });
            } else {
              this.$message.error(res.message);
            }
          });
        }
      } else {
        this.$message.error("请先选择规格！");
      }
    },
    //加入选品池
    inSelectionCart() {
      if (this.sku.length > 0) {
        let goodsId = this.id;
        let itemId = this.sku[this.sku.length - 1].id;
        let quantity = this.num;
        let data = {
          goodsId,
          itemId,
          quantity,
        };
        xbSelectionCart.postXBAddSelection(data).then((res) => {
          if (res.success) {
            this.selectionDate = new Date().getTime();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.error("请先选择规格！");
      }
    },
    //选择送货地址
    openAddress() {
      this.showAddressDialog = true;
    },
    cancelEditedAddress() {
      this.$refs.addressForm.resetFields();
      this.showAddressDialog = false;
    },
    saveEditedAddress() {
      let num = this.num;
      this.addressFlag = 1;
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          let arr = [];
          this.addressList.map((item) => {
            if (this.addressForm.areaArr[0] === item.id) {
              arr.push(item);
            }
            item.children.map((value) => {
              if (this.addressForm.areaArr[1] === value.id) {
                arr.push(value);
              }
              value.children.map((val) => {
                if (this.addressForm.areaArr[2] === val.id) {
                  arr.push(val);
                }
              });
            });
          });
          this.address = `${arr[0].name}${arr[1].name}${arr[2].name}`;
          let arrList = [];
          arr.map((item) => {
            let obj = {};
            obj.id = item.id;
            obj.name = item.name;
            arrList.push(obj);
          });
          saveXBReceivingGoodsAddressInfo(arrList);
          console.log(this.sku);
          this.initSaleNum(
            this.addressForm.areaArr[1],
            this.addressForm.areaArr[2]
          );
          // 清空数据域
          this.addressForm.areaArr = [0, 0, 0];
          this.$refs.addressForm.resetFields();
          this.showAddressDialog = false;
          setTimeout(() => {
            this.num = num;
          }, 500);
        } else {
          return false;
        }
      });
    },
    _getDBAddressMock() {
      dbAddress.getDBAddressMock().then((res) => {
        // console.log("城市数据", res);
        this.addressList = res;
      });
    },
    // 前往详情页
    goToProduct(id) {
      let routeUrl = this.$router.resolve({
        path: "/product",
        query: {
          id: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    toTime(time) {
      let date = new Date(time);
      let month = date.getMonth() + 1;
      month = month > 9 ? month : "0" + month;
      let detailDate = date.getDate();
      detailDate = detailDate > 9 ? detailDate : "0" + detailDate;
      let hour = date.getHours();
      hour = hour > 9 ? hour : "0" + hour;
      let minute = date.getMinutes();
      minute = minute > 9 ? minute : "0" + minute;
      let second = date.getSeconds();
      second = second > 9 ? second : "0" + second;
      return `${month}月${detailDate}日  ${hour}:${minute}:${second}`;
    },
    beforeEnter: function (el) {
      console.log(el);
      // ...
    },
    // 当与 CSS 结合使用时
    // 回调函数 done 是可选的
    enter: function (el, done) {
      el.style.left = null;
      if (this.slide) {
        Velocity(el, { right: "310px", top: "250px" }, { duration: 1000 });
      } else {
        Velocity(el, { right: "0px", top: "250px" }, { duration: 1000 });
      }

      done();
    },
    afterEnter: function (el) {
      // console.log(el);
      // ...
    },
    enterCancelled: function (el) {
      // console.log(el);
      // ...
    },
    slideStatus(data) {
      this.slide = data;
    },
    //获取商品池状态
    getModuleSelection() {
      if (getXBBasicInformation() !== "") {
        this.isModuleSelection =
          getXBBasicInformation().moduleSelection === 1 ? true : false;
      } else {
        setTimeout(() => {
          this.getModuleSelection();
        }, 1000);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.product-container {
  min-height: 100%;
  background: #fff;
  .product-container-main {
    .header-center {
      margin: 0 auto;
      width: 1200px;
    }
    .body-center {
      margin: 0 auto;
      width: 1200px;
    }
    .bread {
      height: 2px;
      background: #df3445;
      margin-bottom: 8px;
    }
    .product-img-message {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .product-img {
        width: 420px;
        height: 490px;
        .bigImg-container {
          width: 420px;
          height: 420px;
          box-sizing: border-box;
          border: 1px solid #e4e4e4;
          border-radius: 8px;
          margin-bottom: 10px;
          font-size: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          .big-img {
            max-width: 100%;
            max-height: 99%;
          }
          .no-img {
            opacity: 0.5;
          }
        }
        .img-banner {
          width: 420px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .lt {
            margin: 0 2px;
            width: 16px;
            height: 40px;
            background: rgba(31, 45, 61, 0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            border-radius: 0;
            border: 0px;
          }
          .lt:hover {
            background: rgba(31, 45, 61, 0.3);
          }
          .gt {
            margin: 0 2px;
            width: 16px;
            height: 40px;
            display: flex;
            padding: 0;
            background: rgba(31, 45, 61, 0.1);
            align-items: center;
            justify-content: center;
            border-radius: 0;
            border: 0px;
          }
          .gt:hover {
            background: rgba(31, 45, 61, 0.3);
          }
          .disabled:hover {
            background: rgba(31, 45, 61, 0.1);
          }
          .list-container {
            height: 60px;
            flex: 1;
            overflow: hidden;
            position: relative;
            .list {
              display: flex;
              height: 60px;
              position: absolute;
              left: 0;
              transition: all 0.5s;
              /* transform: translate(100px, 0); */
              .smallImg-container {
                box-sizing: border-box;
                min-width: 60px;
                height: 60px;
                margin-right: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                .small-img {
                  width: 56px;
                  height: 56px;
                }
              }
            }
          }
        }
      }
      .product-message {
        width: 740px;
        min-height: 420px;
        .trade-name {
          white-space: pre-wrap;
          width: 580px;
          padding: 8px 0;
          font-size: 16px;
          font-weight: 400;
          color: rgba(96, 98, 102, 1);
          line-height: 28px;
          min-height: 28px;
        }
        .vice-title {
          display: flex;
          justify-content: space-between;
          .vice-collection {
            font-size: 12px;
            line-height: 20px;
            min-height: 20px;
            padding: 6px 0 20px 0px;
            cursor: pointer;
            img {
              width: 14px;
              height: 14px;
              vertical-align: middle;
              margin-bottom: 3px;
            }
          }
        }
        .promotion {
          font-size: 12px;
          color: rgba(223, 52, 69, 1);
          line-height: 20px;
          min-height: 20px;
          padding: 6px 0 20px 0px;
        }
        .price {
          height: 80px;
          background: rgba(247, 247, 247, 1);
          border-radius: 2px;
          box-sizing: border-box;
          padding-left: 10px;
          color: #606266;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .price-content {
            display: flex;
            align-items: center;
            padding-bottom: 10px;
          }
          .commission-content {
            height: 20px;
            display: flex;
            align-items: center;
            color: rgba(223, 51, 69, 1);
            font-size: 12px;
            .rate {
              margin-right: 20px;
            }
            p {
              margin-right: 20px;
            }
          }
          .space4 {
            width: 60px;
            padding-right: 10px;
            font-size: 12px;
            letter-spacing: 2px;
          }
          .DF3445 {
            font-size: 24px;
            color: #df3445;
          }
          .no-price {
            font-size: 16px;
            color: #df3445;
          }
        }
        .promotion-not-start {
          .time {
            font-size: 14px;
            padding: 0 20px;
            color: #999999;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            background: rgba(239, 239, 239, 1);
            .time-left {
              display: flex;
              align-items: center;
            }
          }
          .promotion-price {
            height: 50px;
            background: rgba(247, 247, 247, 1);
            display: flex;
            align-items: center;
            .promotion-price-title {
              width: 60px;
              padding: 0 10px;
              color: #606266;
              font-size: 12px;
              letter-spacing: 2px;
            }
            p {
              color: #df3445;
              font-size: 24px;
              i {
                color: #df3445;
                font-size: 16px;
              }
            }
          }
          .commission-content {
            height: 30px;
            padding-left: 10px;
            line-height: 30px;
            display: flex;
            align-items: center;
            color: rgba(223, 51, 69, 1);
            font-size: 12px;
            background: rgba(247, 247, 247, 1);
            .rate {
              margin-right: 20px;
            }
            p {
              margin-right: 20px;
            }
          }
          .promotion-message {
            min-height: 68px;
            background: rgba(247, 247, 247, 1);
            box-sizing: border-box;
            padding-top: 7px;
            display: flex;
            .promotion-message-title {
              width: 60px;
              padding: 0 10px;
              color: #606266;
              font-size: 12px;
              letter-spacing: 2px;
            }
            .promotion-message-content {
              .promotion-message-list {
                display: flex;
                align-items: center;
                font-size: 14px;
                margin-bottom: 10px;
                .promotion-message-lable {
                  padding: 2px 10px;
                  border: 1px solid rgba(223, 52, 69, 1);
                  color: rgba(223, 52, 69, 1);
                  border-radius: 10px;
                  margin-right: 10px;
                  font-size: 12px;
                }
              }
            }
          }
        }
        .promotion-start {
          .time {
            font-size: 14px;
            padding: 0 20px;
            color: #fff;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            background: #df3445;
            .time-left {
              display: flex;
              align-items: center;
            }
            .time-right {
              letter-spacing: 1px;
            }
          }
          .promotion-price {
            height: 50px;
            background: rgba(247, 247, 247, 1);
            display: flex;
            align-items: center;
            .promotion-price-title {
              width: 60px;
              padding: 0 10px;
              color: #606266;
              font-size: 12px;
              letter-spacing: 2px;
            }
            .price-container {
              display: flex;
              align-items: flex-end;
              .new-price {
                color: #df3445;
                font-size: 24px;
                i {
                  color: #df3445;
                  font-size: 16px;
                }
              }
              .old-price {
                margin-left: 16px;
                text-decoration: line-through;
                font-size: 16px;
              }
            }
          }
          .commission-content {
            height: 30px;
            padding-left: 10px;
            display: flex;
            align-items: center;
            line-height: 30px;
            color: rgba(223, 51, 69, 1);
            font-size: 12px;
            background: rgba(247, 247, 247, 1);
            .rate {
              margin-right: 20px;
            }
            p {
              margin-right: 20px;
            }
          }
          .promotion-message {
            min-height: 68px;
            background: rgba(247, 247, 247, 1);
            box-sizing: border-box;
            padding-top: 7px;
            display: flex;
            .promotion-message-title {
              width: 60px;
              padding: 0 10px;
              color: #606266;
              font-size: 12px;
              letter-spacing: 2px;
            }
            .promotion-message-content {
              .promotion-message-list {
                display: flex;
                align-items: center;
                font-size: 14px;
                margin-bottom: 10px;
                .promotion-message-lable {
                  padding: 2px 10px;
                  border: 1px solid rgba(223, 52, 69, 1);
                  color: rgba(223, 52, 69, 1);
                  border-radius: 10px;
                  margin-right: 10px;
                  font-size: 12px;
                }
              }
            }
          }
        }
        .specification {
          box-sizing: border-box;
          border-bottom: 1px solid #e4e4e4;
          padding-left: 10px;
          padding-top: 12px;
        }
        .market-price {
          height: 40px;
          line-height: 40px;
          padding-left: 10px;
          box-sizing: border-box;
          border-bottom: 1px solid #e4e4e4;
          display: flex;
          align-items: center;
          font-size: 12px;
          .market-price-tit {
            width: 60px;
            padding-right: 10px;
            font-weight: 400;
            color: #666;
            line-height: 20px;
            letter-spacing: 2px;
          }
          .market-original-price {
            text-decoration: line-through;
          }
        }
        .points {
          height: 40px;
          padding-left: 10px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e4e4e4;
          font-size: 12px;
          .points-tit {
            width: 60px;
            padding-right: 10px;
            font-weight: 400;
            color: #666;
            line-height: 20px;
            letter-spacing: 2px;
          }
        }
        .address {
          height: 40px;
          padding-left: 10px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e4e4e4;
          .address-tit {
            width: 60px;
            padding-right: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #666;
            line-height: 20px;
            letter-spacing: 2px;
          }
          .address-content {
            font-size: 12px;
            font-weight: 400;
            color: #666;
            cursor: pointer;
          }
          .address-text {
            font-size: 12px;
            font-weight: 400;
            color: #666;
            margin-right: 16px;
          }
          .address-red {
            color: #df3445;
          }
        }
        .number {
          height: 40px;
          margin-top: 20px;
          padding-left: 10px;
          margin-bottom: 10px;
          display: flex;
          align-items: flex-start;
          .number-tit {
            width: 60px;
            padding-right: 10px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(96, 98, 102, 1);
            line-height: 20px;
            letter-spacing: 2px;
          }
          .stock {
            line-height: 40px;
            height: 18px;
            font-size: 12px;
            color: rgba(96, 98, 102, 1);
            letter-spacing: 1px;
            padding-left: 10px;
          }
        }
        .button {
          height: 40px;
          display: flex;
          .add-to-cart {
            width: 128px;
            height: 40px;
            background: rgba(223, 52, 69, 0.75);
            border: 0;
            font-size: 16px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            padding: 0;
            border-radius: 4px;
          }
          .add-to-cart:hover {
            background: rgba(223, 52, 69, 1);
          }
          .add-to-select:hover {
            background: #fff;
          }
          .sample {
            width: 128px;
            height: 40px;
            background: rgba(255, 255, 255, 1);
            border: 2px solid rgba(223, 52, 69, 1);
            color: rgba(223, 52, 69, 1);
            border-radius: 2px;
            font-size: 16px;
            font-weight: 500;
            padding: 0;
            border-radius: 4px;
            margin-left: 20px;
          }
          .disabled-sample {
            background: rgba(145, 147, 152, 1);
            color: #fff;
            border: 0;
          }
          .nothing {
            width: 128px;
            height: 40px;
            background: rgba(145, 147, 152, 1);
            border-radius: 2px;
            border: 2px solid rgba(145, 147, 152, 1);
            font-size: 16px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            padding: 0;
          }
          .collection {
            margin-left: 20px;
            width: 72px;
            height: 40px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            border: 2px solid rgba(223, 52, 69, 1);
            font-size: 16px;
            font-weight: 500;
            color: rgba(223, 52, 69, 1);
            padding: 0;
          }
          .add-to-select {
            width: 128px;
            height: 40px;
            margin-left: 20px;
            padding: 0;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 500;
            background: rgba(255, 255, 255, 1);
            border: 2px solid rgba(223, 52, 69, 1);
            color: rgba(223, 52, 69, 1);
          }
          .disabled-select {
            background: rgba(145, 147, 152, 1);
            color: #fff;
            border: 0;
          }
          .disabled-select:hover {
            background: rgba(145, 147, 152, 1);
          }
          .img-fade-container {
            /* position: absolute; */
            z-index: 99;
          }
        }
        .lower-shelf {
          height: 20px;
          border-top: 1px solid #e4e4e4;
          padding-top: 18px;
          font-size: 20px;
          color: rgba(102, 102, 102, 1);
        }
      }
      .product-delete {
        width: 740px;
        line-height: 100px;
        font-size: 20px;
      }
    }
    /* 套餐 */
    .package {
      margin-bottom: 20px;
      .package-list {
        display: flex;
        transform: translateX(-80px);
        width: 920px;
        li {
          width: 120px;
          box-sizing: border-box;
          padding-top: 16px;
          margin-left: 60px;
          position: relative;
          display: flex;
          align-items: center;
          flex-direction: column;
          svg {
            position: absolute;
            top: 60px;
            left: -38px;
          }
          .img {
            width: 100px;
            height: 100px;
            margin-bottom: 10px;
            img {
              max-width: 100%;
              max-height: 100%;
              cursor: pointer;
            }
          }
          .tit {
            width: 120px;
            font-size: 12px;
            color: rgba(96, 98, 102, 1);
            line-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            margin-bottom: 10px;
          }
          .tit:hover {
            color: #df3445;
            cursor: pointer;
          }
          .price {
            color: #df3445;
            font-size: 14px;
            width: 120px;
            margin-bottom: 8px;
          }
          .quantity {
            width: 120px;
            font-size: 12px;
            color: rgba(96, 98, 102, 1);
          }
        }
        li:first-child {
          svg {
            display: none;
          }
        }
      }
      .total-price {
        position: relative;
        padding-top: 28px;
        padding-left: 20px;
        svg {
          position: absolute;
          top: 50%;
          margin-top: -21px;
          left: -37px;
        }
        .package-price {
          color: #df3445;
          margin-bottom: 10px;
          .tit {
            font-size: 14px;
          }
          .prc {
            font-weight: 600;
            font-size: 20px;
          }
        }
        .price {
          .tit {
            font-size: 12px;
            color: #999999;
          }
          .prc {
            font-size: 14px;
            color: #c2c2c2;
            text-decoration: line-through;
          }
        }
        .el-button {
          margin-top: 12px;
          width: 100px;
          height: 32px;
          background: rgba(223, 52, 69, 1);
          border-radius: 2px;
          border: 2px solid rgba(223, 52, 69, 1);
          font-size: 12px;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .recommend-detail {
      display: flex;
      min-height: 100px;
      justify-content: space-between;
      margin-bottom: 30px;
      .title {
        height: 40px;
        background: #f7f7f7;
        font-size: 16px;
        font-weight: 400;
        color: rgba(96, 98, 102, 1);
        line-height: 40px;
        letter-spacing: 2px;
        padding-left: 10px;
        border: 1px solid #e4e4e4;
        border-bottom: 0;
        margin: 0;
      }
      .recommend {
        width: 200px;
        /* visibility: hidden; */
        .recommend-list {
          li {
            border: 1px solid #e4e4e4;
            border-top: 0;
            box-sizing: border-box;
            padding-top: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .img {
              width: 160px;
              height: 160px;
              box-sizing: border-box;
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                max-width: 160px;
                max-height: 160px;
                cursor: pointer;
              }
            }
            p {
              font-size: 14px;
              font-weight: 500;
              color: rgba(96, 98, 102, 1);
              line-height: 20px;
              letter-spacing: 1px;
              width: 160px;
              overflow: hidden;
              font-size: 12px;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              letter-spacing: 0px;
              margin-bottom: 8px;
            }
            p:hover {
              color: rgba(223, 52, 69, 1);
              cursor: pointer;
            }
            .price {
              width: 160px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(223, 52, 69, 1);
              line-height: 20px;
              letter-spacing: 1px;
              margin-bottom: 10px;
            }
          }
        }
      }
      .detail {
        width: 980px;
        min-height: 800px;
        .noContent {
          width: 100%;
          height: 500px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            opacity: 0.5;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.product-container {
  .number-price {
    margin-top: 10px;
    .el-input-number {
      width: 80px;
      line-height: 31px;
      .el-icon-arrow-up {
        color: #979797;
        &::before {
          content: "\E6D9";
        }
      }
      .el-icon-arrow-down {
        color: #979797;
        &::before {
          content: "\E6D8";
        }
      }
      .el-input-number__decrease {
        box-sizing: border-box;
        width: 18px;
        height: 16px;
        border-radius: 0px 0px 2px 0px;
        border: 1px solid rgba(151, 151, 151, 1);
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        right: -12px;
        bottom: 0px;
        border-top: none;
      }
      .el-input-number__increase {
        box-sizing: border-box;
        width: 18px;
        height: 16px;
        border-radius: 0px 2px 0px 0px;
        border: 1px solid rgba(151, 151, 151, 1);
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        right: -12px;
        top: 0px;
      }
      .el-input {
        width: 75px;
        .el-input__inner {
          width: 100%;
          height: 32px;
          border-radius: 2px;
          border: 1px solid rgba(151, 151, 151, 1);
          font-size: 16px;
          color: rgba(96, 98, 102, 1);
          padding-right: 0px;
        }
      }
    }
  }
  .product-container-main {
    .el-radio-group {
      height: 24px;
      .el-radio-button {
        height: 24px;
        margin-right: 8px;
        .el-radio-button__inner {
          height: 24px;
          line-height: 24px;
          padding: 0;
          min-width: 60px;
          padding: 0 8px;
          border-radius: 2px;
          border: 1px solid rgba(151, 151, 151, 1);
          box-shadow: 0 0 0 0;
          color: #606266;
          background: #fff;
        }
      }
      .el-radio-button.is-active {
        .el-radio-button__inner {
          border: 1px solid #df3445;
        }
      }
      .el-radio-button:hover {
        .el-radio-button__inner {
          color: #df3445;
        }
      }
    }
    .number {
      .el-input-number {
        width: 80px;
        line-height: 31px;
        .el-icon-arrow-up {
          color: #979797;
        }
        .el-icon-arrow-down {
          color: #979797;
        }
        .el-input-number__decrease {
          box-sizing: border-box;
          width: 18px;
          height: 14px;
          border-radius: 2px;
          border: 1px solid rgba(151, 151, 151, 1);
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .el-input-number__increase {
          box-sizing: border-box;
          width: 18px;
          height: 14px;
          border-radius: 2px;
          border: 1px solid rgba(151, 151, 151, 1);
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .el-input {
          width: 56px;
          .el-input__inner {
            padding: 0 8px;
            height: 32px;
            border-radius: 2px;
            border: 1px solid rgba(151, 151, 151, 1);
            font-size: 16px;
            color: rgba(96, 98, 102, 1);
            line-height: 28px;
          }
        }
      }
    }
    /* 套餐 */
    .package {
      .el-tabs--border-card {
        box-shadow: 0 0 0 0;
        border: 1px solid rgba(228, 228, 228, 1);
        .el-tabs__header {
          background: #f8f8f8;
          height: 32px;
          border: 0;
          .el-tabs__item {
            border: 0;
            color: #606266;
            min-width: 80px;
            max-width: 170px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding: 0 15px;
            font-size: 12px;
            height: 32px;
            line-height: 32px;
          }
          .is-active {
            background: #df3445;
            color: #fff;
          }
        }
        .el-tabs__content {
          height: 220px;
          box-sizing: border-box;
          border-top: 0;
          padding: 0;
          padding-left: 60px;
          .el-tab-pane {
            display: flex;
            justify-content: flex-start;
          }
        }
      }
    }
    .detail {
      width: 980px;
      min-height: 800px;
      font-size: 14px;
      img {
        max-width: 100%;
      }
      table {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
        width: 100% !important;
      }
      table td,
      table th {
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        padding: 3px 5px;
      }
      table th {
        border-bottom: 2px solid #ccc;
        text-align: center;
      }

      /* blockquote 样式 */
      blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
      }

      /* code 样式 */
      code {
        display: inline-block;
        *display: inline;
        *zoom: 1;
        background-color: #f1f1f1;
        border-radius: 3px;
        padding: 3px 5px;
        margin: 0 3px;
      }
      pre code {
        display: block;
      }

      /* ul ol 样式 */
      ul,
      ol {
        margin: 10px 0 10px 20px;
        li {
          line-height: 32px;
        }
      }
      ol {
        li {
          list-style: decimal;
        }
      }
      ul {
        li {
          list-style: disc;
        }
      }
      p {
        line-height: 1.5;
        margin: 10px 0;
      }
    }
  }
  .address-dialog {
    .el-dialog {
      width: 440px;
      .el-dialog__body {
        .el-form {
          .el-form-item {
            margin-bottom: 20px;
            &:last-child {
              margin-bottom: 0;
            }
            .el-input {
              .el-input__inner {
                width: 300px;
              }
            }
            .el-cascader {
              .el-input {
                .el-input__suffix {
                  right: 0px;
                }
              }
            }
          }
        }
      }
      .el-dialog__footer {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        .btn {
          width: 96px;
          height: 32px;
          border-radius: 4px;
          margin-bottom: 20px;
        }
        .cancel-btn {
          margin-right: 24px;
        }
        .save-btn {
          color: #ffffff;
          background: rgba(61, 116, 242, 1);
        }
      }
    }
  }
}
</style>
